import React from "react";
import { Container } from "react-bootstrap";

export const Channels: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                Channels......
            </Container>
        </React.Fragment>
    );
}